'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyBag = exports.Context = undefined;

var _Context = require('./Context');

var _Context2 = _interopRequireDefault(_Context);

var _PropertyBag = require('./PropertyBag');

var _PropertyBag2 = _interopRequireDefault(_PropertyBag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Core
 */

exports.Context = _Context2.default;
exports.PropertyBag = _PropertyBag2.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/index.js
// module id = 318
// module chunks = 0